import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { BaseTypography as t } from "../../common/components/BaseStyledComponents/BaseTypography.js";
import r from "@mui/joy/Stack";
const i = ({ title: i2, children: n, bg: l }) => o(r, { sx: { borderRadius: "8px", px: 0.5, py: 0.25, bgcolor: l || "none" }, children: [e(t, { lightColor: "text.tertiary", level: "body-xs", fontWeight: 400, children: i2 }), e(t, { level: "body-xs", fontWeight: 600, children: n })] });
export {
  i as CalendarCellElementInfoRow,
  i as default
};
//# sourceMappingURL=CalendarCellElementInfoRow.js.map
